var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item)?_c('div',[_c('GmapMap',{ref:"gmap",style:({ width: '100%', height: _vm.height ? _vm.height : '55vh' }),attrs:{"center":{ lat: _vm.centerLat, lng: _vm.centerLng },"zoom":10,"options":{
      zoomControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      disableDefaultUi: false,
    }}},[_c('GmapPolyline',{attrs:{"path":_vm.polylineListTwo,"options":{ strokeWidth: 20, strokeColor: '#2516c9' }},on:{"update:path":function($event){_vm.polylineListTwo=$event}}}),_c('GmapPolyline',{attrs:{"path":_vm.polylineListOne,"options":{ strokeWidth: 20, strokeColor: '#C43A3A' }},on:{"update:path":function($event){_vm.polylineListOne=$event}}}),_c('GmapMarker',{attrs:{"title":"'Yükleme Noktası'","label":{
        text: 'Yükleme Noktası',
        color: 'white',
        className:
          'absolute bottom-4 -right-12 text-xs  px-2 text-xs font-bold bg-blue-700 rounded tracking-widest',
        fontSize: '8.5px',
      },"position":_vm.outpointPosition,"icon":require('@/assets/marker/waypoint.png')}}),_c('GmapMarker',{attrs:{"title":"'Teslim Noktası'","label":{
        text: 'Teslim Noktası',
        color: 'white',
        className:
          'absolute bottom-4 -right-8 text-xs  px-2 text-xs font-bold bg-blue-700 rounded tracking-widest',
        fontSize: '8.5px',
      },"position":_vm.targetPosition,"icon":require('@/assets/marker/flag.png')}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }